exports = module.exports = require("../../../../../../../usr/lib/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".besidaMob-imagePlaceholder__root--3vY43{-ms-flex-align:center;-ms-flex-pack:center;-webkit-box-align:center;-webkit-box-pack:center;align-items:center;background:#f6f8fd;bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;justify-content:center;left:0;position:absolute;right:0;top:0}.besidaMob-imagePlaceholder__icon--zFLUb{display:inline-block;fill:#dfe1f0;height:40%;vertical-align:middle;width:40%}", ""]);

// exports
exports.locals = {
	"root": "besidaMob-imagePlaceholder__root--3vY43",
	"icon": "besidaMob-imagePlaceholder__icon--zFLUb"
};